export default "__VITE_ASSET__CziOw5LG__"